import { render, staticRenderFns } from "./AccommodationsSearch.vue?vue&type=template&id=0834d45c&lang=pug&"
import script from "./AccommodationsSearch.vue?vue&type=script&lang=js&"
export * from "./AccommodationsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports